import React from "react";
import {
    Tooltip,
    TooltipPlacement,
    TooltipTriggerType,
} from "../../../../common/Tooltip";
import { OnHoverTooltip, Preloader } from "../../../../common";
import { Transaction } from "../../../../../types/amr-pipeline/models/Transaction";
import { useGetTransactionLink } from "../../../../../effects/useGetTransactionLink";
import { useCopyToClipboard } from "../../../../../effects/useCopyToClipboard";
import { amrPipelineDetailedActions } from "../../../../../actions";
import { useAppDispatch } from "../../../../../effects/useAppDispatch";

interface Props {
    transaction: Transaction;
    children: React.ReactNode | string;
    handleShare: () => void;
    className?: string;
}

export function ShareTransactionButton({
    transaction,
    children,
    handleShare,
    className,
}: Props) {
    const [visible, setVisible] = React.useState(false);
    const dispatch = useAppDispatch();

    const showCopiedNotification = () =>
        dispatch(amrPipelineDetailedActions.showCopiedLinkNotification());
    const { transactionLink, isLinkLoading } = useGetTransactionLink(
        transaction,
        visible
    );
    const { copyToClipboard } = useCopyToClipboard(showCopiedNotification);

    const renderOverlay = () => {
        return (
            <div className="share-transaction-popover">
                <button
                    onClick={() => {
                        handleShare();
                        setVisible(false);
                    }}
                    className="btn-link regular"
                >
                    Share transaction via email
                </button>
                <button
                    onClick={() => copyToClipboard(transactionLink)}
                    className="btn-link regular"
                >
                    Copy link
                </button>
            </div>
        );
    };

    return (
        <Tooltip
            placement={TooltipPlacement.BottomRight}
            onVisibleChange={setVisible}
            trigger={TooltipTriggerType.Click}
            visible={visible && !isLinkLoading}
            overlay={renderOverlay}
        >
            <div className="share-transaction-btn">
                {isLinkLoading ? (
                    <Preloader inProgress small />
                ) : (
                    <OnHoverTooltip
                        overlay="Share transaction and track views"
                        disabled={visible}
                    >
                        <button className={className}>
                            {children}
                        </button>
                    </OnHoverTooltip>
                )}
            </div>
        </Tooltip>
    );
}

